module.exports = __webpack_public_path__ + "img/wallet.2f42d412.svg";